<template>
  <a-modal
    title="选择子账户"
    :width="900"
    :visible="visible"
    @cancel="handleCancel"
    :footer="null"
    :bodyStyle="{}"
  >
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="查询类型">
              <a-select v-model="queryParam.type" placeholder="请选择查询类型" allowClear>
                <a-select-option value="1">机器人子账户</a-select-option>
                <a-select-option value="2">微信ID</a-select-option>
                <a-select-option value="3">微信昵称</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="关键字">
              <a-input v-model="queryParam.keywords" placeholder="请先选择查询类型" />
            </a-form-item>
          </a-col>
          <template v-if="advanced"></template>
          <a-col :md="!advanced && 8 || 24" :sm="24">
            <span
              class="table-page-search-submitButtons"
              :style="advanced && { float: 'right', overflow: 'hidden' } || {} "
            >
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <s-table ref="table" rowKey="id" :columns="columns" :data="loadData">
      <span slot="avatar" slot-scope="text, record">
        <a-avatar shape="square" icon="user" :src="record.wx_avatar" />
      </span>
      <span slot="nickname" slot-scope="text">
        <a v-if="!text.nickname">未设置</a>
        <span v-else>{{text.nickname}}</span>
      </span>
      <template slot="action" slot-scope="text,record">
        <a @click="onchange(record)">选择</a>
      </template>
    </s-table>
  </a-modal>
</template>

<script>
const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    width: 80
  },
  {
    title: '头像',
    scopedSlots: { customRender: 'avatar' },
    width: 80
  },
  {
    title: '微信昵称',
    scopedSlots: { customRender: 'nickname' }
  },
  {
    title: '微信ID',
    dataIndex: 'wx_id'
  },
  {
    title: '操作',
    width: 60,
    scopedSlots: { customRender: 'action' }
  }
]
import DeviceApi from '@/api/device'
import { STable } from '@/components'
export default {
  components: {
    STable
  },
  data() {
    return {
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      columns,
      loading: false,
      visible: false,
      currentRobotId: null,
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return DeviceApi.getList(Object.assign(parameter, this.queryParam))
      }
    }
  },
  created() {},
  methods: {
    show() {
      this.visible = true
    },
    handleCancel() {
      this.visible = false
    },
    onchange(record) {
      this.$emit('change', record)
    }
  }
}
</script>

<style lang="less" scoped>
</style>
